/**
 * Purpose:
 *   Renders submenu with child menu items.
 */

import { cx } from '@/util/functions/cx';
import {
  MENU_SUBMENU,
  MENU_SUBMENU_COLLAPSED,
  MENU_SUBMENU_INNER,
} from './Menu.styles';
import { MenuItemSubmenuItem } from './MenuItemSubmenuItem';
import type { MenuItemConfig } from '@/types/menu';

export interface IMenuItemSubmenuProps {
  item: MenuItemConfig;
  isExpanded: boolean;
  isChildActive: (item: MenuItemConfig) => boolean;
  onNavigate: (href: string) => void;
  onLinkClick?: () => void;
  submenuRef: React.RefObject<HTMLDivElement | null>;
  buttonId: string;
  submenuId: string;
  style?: React.CSSProperties;
}

export function MenuItemSubmenu({
  item,
  isExpanded,
  isChildActive,
  onNavigate,
  onLinkClick,
  submenuRef,
  buttonId,
  submenuId,
  style,
}: IMenuItemSubmenuProps) {
  return (
    <div
      id={submenuId}
      className={cx(MENU_SUBMENU, !isExpanded && MENU_SUBMENU_COLLAPSED)}
      style={style}
      aria-labelledby={buttonId}
      aria-hidden={!isExpanded}
      inert={!isExpanded || undefined}
    >
      <div ref={submenuRef} className={MENU_SUBMENU_INNER}>
        {item.children?.map((child) => (
          <MenuItemSubmenuItem
            key={child.id}
            child={child}
            isActive={isChildActive(child)}
            isFocusable={isExpanded}
            onNavigate={onNavigate}
            onLinkClick={onLinkClick}
          />
        ))}
      </div>
    </div>
  );
}
